import React, { FC } from "react";

import { IgLoading } from "@intelligems/ig-theme";
import { Box } from "@mui/material";

export interface LoadingProps {
  message?: string | boolean;
  centered?: boolean;
}

const Loading: FC<LoadingProps> = ({ centered }) => {
  return (
    <Box
      className={centered ? "ig-loading-centered" : undefined}
      sx={{
        display: "block",
        position: "absolute",
        top: "50%",
        left: "calc(50vw + 71px)",
      }}
    >
      <IgLoading />
    </Box>
  );
};

export default Loading;
